import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryUserTreeList } from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import { httpAction } from '@/api/manage';
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'ProblemRectificationModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '问题整改表单',
      tableName: 'om_problem_rectification',
      form_fields: ['siteId', 'userId', 'checkCompany', 'principledIssues', 'keyIssues', 'remark'],
      form_fields_time: ['checkDate'],
      validatorRules: {
        siteId: {
          rules: [{
            required: true,
            message: '请输入站点id!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请输入运维人员!'
          }]
        },
        checkDate: {
          rules: [{
            required: true,
            message: '请输入检查时间!'
          }]
        }
      },
      siteName: '',
      userTree: [] //人员信息

    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    moment: moment,
    add: function add() {
      this.edit({});
    },
    getCurrentData: function getCurrentData() {
      return new Date().toLocaleDateString();
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.id) {
        this.siteName = this.model.siteName;
      } else {
        this.model.checkDate = new Date().toLocaleDateString();
        this.model.userId = this.$store.getters.userInfo.id;
        this.model.status = '1';
      }

      this.loadTreeList();
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          formData.siteId = formData.siteId ? formData.siteId : _this2.currentSiteId;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};